// src/services/authService.js
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  updateProfile,
} from "firebase/auth";
import {
  doc, setDoc, getDoc, serverTimestamp,
} from "firebase/firestore";
import { auth, db } from "./firebase";

// ── تحويل رقم التليفون → email وهمي داخلي ─────────────────
// 01012345678 أو 201012345678 → 201012345678@rido.app
function phoneToFakeEmail(phone) {
  const digits = phone.replace(/\D/g, "");
  if (digits.startsWith("20")) return `${digits}@rido.app`;
  if (digits.startsWith("0"))  return `20${digits.slice(1)}@rido.app`;
  return `20${digits}@rido.app`;
}

// ── تنسيق رقم التليفون للحفظ في Firestore ─────────────────
export function formatPhone(phone) {
  const digits = phone.replace(/\D/g, "");
  if (digits.startsWith("20")) return `+${digits}`;
  if (digits.startsWith("0"))  return `+20${digits.slice(1)}`;
  return `+20${digits}`;
}

// ── تسجيل عميل جديد ───────────────────────────────────────
export async function registerClient({ name, phone, password }) {
  const email = phoneToFakeEmail(phone);
  const cred  = await createUserWithEmailAndPassword(auth, email, password);
  await updateProfile(cred.user, { displayName: name });

  const userDoc = {
    id:        cred.user.uid,
    name,
    phone:     formatPhone(phone),
    role:      "client",
    createdAt: serverTimestamp(),
  };
  await setDoc(doc(db, "users", cred.user.uid), userDoc);
  return userDoc;
}

// ── تسجيل كابتن جديد ──────────────────────────────────────
export async function registerCaptain({
  name, phone, password, car, plate,
  licenseUrl, idUrl, photoUrl, carPhotoUrls,
}) {
  const email = phoneToFakeEmail(phone);
  const cred  = await createUserWithEmailAndPassword(auth, email, password);
  await updateProfile(cred.user, { displayName: name });

  const uid     = cred.user.uid;
  const userDoc = {
    id: uid, name,
    phone:        formatPhone(phone),
    car, plate,
    role:         "captain",
    status:       "pending",
    licenseUrl:   licenseUrl   || null,
    idUrl:        idUrl        || null,
    photoUrl:     photoUrl     || null,
    carPhotoUrls: carPhotoUrls || [],
    rating: 0, ratingCount: 0, ratingSum: 0,
    trips: 0, balance: 0, available: false,
    createdAt: serverTimestamp(),
  };
  await setDoc(doc(db, "users", uid), userDoc);

  const verify = await getDoc(doc(db, "users", uid));
  if (!verify.exists()) throw new Error("فشل حفظ البيانات — يرجى المحاولة مرة أخرى");
  return userDoc;
}

// ── تسجيل الدخول (عميل / كابتن / أدمن) ───────────────────
// الكل يدخل بنفس الطريقة — رقم تليفون + باسورد
// الأدمن عنده رقم تليفون محفوظ في Firestore
export async function loginWithPhone(phone, password) {
  const email = phoneToFakeEmail(phone);
  const cred  = await signInWithEmailAndPassword(auth, email, password);
  const snap  = await getDoc(doc(db, "users", cred.user.uid));
  if (!snap.exists()) throw new Error("لم يتم العثور على بيانات المستخدم");
  return snap.data();
}

// ── تسجيل الخروج ──────────────────────────────────────────
export async function logout() {
  await signOut(auth);
}

// ── جلب profile بـ UID ────────────────────────────────────
export async function getUserProfile(uid) {
  const snap = await getDoc(doc(db, "users", uid));
  return snap.exists() ? snap.data() : null;
}